import React, { useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { findIndex } from "../../../utils";

import { addVariantToCartlist } from "../../../actions/cartlistActions";
import { addToWishlist } from "../../../actions/wishlistActions";
import { API_URL, APP_URL, currency } from "../../../constants/miscellaneous";
import { flyingAnimation } from "../../../utils/helpers";

function ProductTwo(props) {
  const { product, onAddToCart, isWishlist, onToggleWishlist } = props;
  const imgRef = useRef(null);
  const addToCartHandler = () => {
    if (0 !== product.stock) onAddToCart(product, 1);
  };

  const addToWishlistHandler = () => {
    if (isWishlist) {
      window.location = APP_URL + "/shop/wishlist";
    } else {
      onToggleWishlist(product, isWishlist);
    }
  };

  return product ? (
    <div className="product" ref={imgRef} id={"prod" + product.id}>
      <figure className="product-media">
        {product.images.length > 0 && (
          <Link to={`${APP_URL}/product/default/${product.id}`}>
            <LazyLoadImage
              alt="product"
              src={`${API_URL}/uploads/variant_images/${product.images[0].fileName}`}
              threshold={400}
              id={"img" + product.id}
            />
          </Link>
        )}

        <button
          className="btn-product btn-wishlist"
          title="Ajouter aux favoris"
          onClick={(e) => props.addToWishlist(product.id)}
        ></button>
      </figure>

      <div className="product-body product-action-inner">
        <button
          className="btn-product btn-cart"
          onClick={(e) => {
            flyingAnimation(product.id, imgRef.current);

            // props.addVariantToCartlist(product.id, 1, false);
          }}
        ></button>

        <h3 className="product-title">
          <Link to={`${APP_URL}/product/default/${product.id}`}>
            {product.nameFr}
          </Link>
        </h3>

        {0 === product.stock ? (
          <div className="product-price">
            <span className="new-price">
              {product.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              {currency}
            </span>
          </div>
        ) : 0 < product.discount ? (
          <div className="product-price">
            <span className="new-price">
              {product.salePrice.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              {currency}
            </span>
            <span className="old-price">
              {product.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              {currency}
            </span>
          </div>
        ) : (
          <div className="product-price">
            {product.price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            {currency}
          </div>
        )}
      </div>
    </div>
  ) : (
    " "
  );
}

export const mapStateToProps = (state, ownprops) => {
  return {
    isWishlist:
      findIndex(
        state.wishlist.list,
        (item) => item.id === ownprops.product.id
      ) !== -1
        ? true
        : false,
  };
};

export default connect(mapStateToProps, {
  addVariantToCartlist,
  addToWishlist,
})(ProductTwo);
